module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "primary justify-center"
  }, [_c('v-flex', {
    attrs: {
      "sm12": ""
    }
  }, [_c('h6', {
    staticClass: "white--text text-xs-center"
  }, [_vm._v("Clientes")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dias,
      "dark": "",
      "label": "Día:",
      "itemText": "text",
      "itemValue": "value"
    },
    on: {
      "change": function($event) {
        return _vm.filtrardia($event)
      }
    },
    model: {
      value: (_vm.dia),
      callback: function($$v) {
        _vm.dia = $$v
      },
      expression: "dia"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.semanas,
      "dark": "",
      "label": "Semana:",
      "itemText": "text",
      "itemValue": "value"
    },
    on: {
      "change": function($event) {
        return _vm.filtrarsemana($event)
      }
    },
    model: {
      value: (_vm.semana),
      callback: function($$v) {
        _vm.semana = $$v
      },
      expression: "semana"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.rutas,
      "itemText": "nombre",
      "label": "Rutas",
      "single-line": "",
      "bottom": "",
      "dark": ""
    },
    on: {
      "change": function($event) {
        return _vm.filtrarruta($event)
      }
    },
    model: {
      value: (_vm.ruta),
      callback: function($$v) {
        _vm.ruta = $$v
      },
      expression: "ruta"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "dark": "",
      "name": "input-1",
      "prepend-icon": "search",
      "label-icon": "search"
    },
    on: {
      "keyup": _vm.buscar
    },
    model: {
      value: (_vm.busqueda),
      callback: function($$v) {
        _vm.busqueda = $$v
      },
      expression: "busqueda"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-btn', {
    staticClass: "accent",
    attrs: {
      "absolute": "",
      "dark": "",
      "small": "",
      "fab": "",
      "button": "",
      "right": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), (!_vm.editarorden) ? _c('v-btn', {
    staticClass: "blue",
    attrs: {
      "absolute": "",
      "dark": "",
      "small": "",
      "fab": "",
      "button": "",
      "center": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.editarorden = !_vm.editarorden
      }
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (_vm.editarorden) ? _c('v-btn', {
    staticClass: "red",
    attrs: {
      "absolute": "",
      "dark": "",
      "small": "",
      "fab": "",
      "button": "",
      "center": ""
    },
    on: {
      "click": _vm.guardartodo
    },
    nativeOn: {
      "click": function($event) {
        _vm.editarorden = !_vm.editarorden
      }
    }
  }, [_c('v-icon', [_vm._v("save")])], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-layout', [_c('v-flex', {
    staticStyle: {
      "overflow-x": "auto"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', {
    staticClass: "pa-0 ma-0"
  }), _vm._v(" "), _c('th', {
    staticClass: "pa-0 ma-0"
  }), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editarorden),
      expression: "editarorden"
    }]
  }, [_vm._v("nuevo")]), _vm._v(" "), _c('th', [_vm._v("Cliente")]), _vm._v(" "), _c('th', [_vm._v("Direccion")]), _vm._v(" "), _c('th', [_vm._v("Código")]), _vm._v(" "), _c('th', [_vm._v("ultima compra")]), _vm._v(" "), _c('th', [_vm._v("deuda")]), _vm._v(" "), _c('th', [_vm._v("Orden")]), _vm._v(" "), _c('th', [_vm._v("Ubicacion")])]), _vm._v(" "), _c('tbody', {
    staticClass: "ma-0 pa-0"
  }, _vm._l((_vm.clientes.results), function(cliente) {
    return _c('tr', [_c('td', {
      staticClass: "text-xs-left pa-0"
    }, [_c('v-btn', {
      staticClass: "red--text text--darken-2 btn--small",
      attrs: {
        "icon": "",
        "pa-0": "",
        "ma-0": ""
      },
      on: {
        "click": function($event) {
          return _vm.eliminar(cliente)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-left pa-0"
    }, [_c('v-btn', {
      staticClass: "blue--text text--darken-2 ",
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.editar(cliente)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), (_vm.editarorden) ? _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0 ma-0"
    }, [_c('v-text-field', {
      attrs: {
        "label": "",
        "singleLine": ""
      },
      on: {
        "input": function($event) {
          return _vm.guardarorden($event, cliente)
        }
      },
      model: {
        value: (cliente.orden),
        callback: function($$v) {
          _vm.$set(cliente, "orden", $$v)
        },
        expression: "cliente.orden"
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0 ",
      class: cliente.malcliente ? 'red--text' : cliente.zero_last3 === 3 ? 'orange--text' : 'black--text',
      on: {
        "click": function($event) {
          return _vm.crearfactura(cliente)
        }
      }
    }, [_vm._v(_vm._s(cliente.nombre))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0 ",
      class: cliente.malcliente ? 'red--text' : cliente.zero_last3 === 3 ? 'orange--text' : 'black--text'
    }, [_vm._v(_vm._s(cliente.direccion_completa))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(cliente.codigo))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0 ma-0"
    }, [_vm._v(_vm._s(cliente.ultima))]), _vm._v(" "), (cliente.debe) ? _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0 ma-0 red--text"
    }, [_vm._v(_vm._s(cliente.total))]) : _vm._e(), _vm._v(" "), (!cliente.debe) ? _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0 ma-0"
    }, [_vm._v(_vm._s(cliente.total))]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0 ma-0"
    }, [_vm._v(_vm._s(cliente.orden))]), _vm._v(" "), (cliente.estado_ubiacion) ? _c('td', {
      staticClass: "text-xs-center text-xs-center pa-0 ma-0 blue--text",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.actualizarubicacion(cliente.id)
        }
      }
    }, [_c('v-icon', {
      staticClass: "blue--text",
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("place")])], 1) : _vm._e(), _vm._v(" "), (!cliente.estado_ubiacion) ? _c('td', {
      staticClass: "text-xs-center text-xs-center pa-0 ma-0 red--text",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.actualizarubicacion(cliente.id)
        }
      }
    }, [_c('v-icon', {
      staticClass: "red--text",
      attrs: {
        "color": "red"
      }
    }, [_vm._v("place")])], 1) : _vm._e()])
  }), 0)])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-center"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [(_vm.clientes.previous) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.prev(_vm.clientes.previous)
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("skip_previous")])], 1) : _vm._e(), _vm._v(" "), (_vm.clientes.next) ? _c('v-btn', {
    attrs: {
      "fab": "",
      "dark": "",
      "small": "",
      "primary": ""
    },
    on: {
      "click": function($event) {
        return _vm.next(_vm.clientes.next)
      }
    }
  }, [_c('v-icon', [_vm._v("skip_next")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    attrs: {
      "primary": ""
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(" Cliente ")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Nombre:",
      "required": "",
      "singleLine": ""
    },
    model: {
      value: (_vm.cliente.nombre),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "nombre", $$v)
      },
      expression: "cliente.nombre"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nit:",
      "singleLine": ""
    },
    model: {
      value: (_vm.cliente.nit),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "nit", $$v)
      },
      expression: "cliente.nit"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.listaDepartamentos,
      "label": "Departamento:*",
      "itemText": "text",
      "itemValue": "value"
    },
    model: {
      value: (_vm.cliente.departamento),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "departamento", $$v)
      },
      expression: "cliente.departamento"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.municipios,
      "label": "Municipio:*",
      "itemText": "text",
      "itemValue": "value"
    },
    model: {
      value: (_vm.cliente.municipio),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "municipio", $$v)
      },
      expression: "cliente.municipio"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Avenida:",
      "flat": "solo"
    },
    model: {
      value: (_vm.cliente.avenida),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "avenida", $$v)
      },
      expression: "cliente.avenida"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Calle:",
      "flat": "solo"
    },
    model: {
      value: (_vm.cliente.calle),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "calle", $$v)
      },
      expression: "cliente.calle"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.zonas,
      "label": "Zona:",
      "itemText": "text",
      "itemValue": "value"
    },
    model: {
      value: (_vm.cliente.zona),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "zona", $$v)
      },
      expression: "cliente.zona"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Barrio o Aldea:",
      "flat": "solo"
    },
    model: {
      value: (_vm.cliente.barrio_aldea),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "barrio_aldea", $$v)
      },
      expression: "cliente.barrio_aldea"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Colonia o Caserío:",
      "flat": "solo"
    },
    model: {
      value: (_vm.cliente.colonia_caserio),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "colonia_caserio", $$v)
      },
      expression: "cliente.colonia_caserio"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Direccion:",
      "flat": "solo"
    },
    model: {
      value: (_vm.cliente.direccion),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "direccion", $$v)
      },
      expression: "cliente.direccion"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Referencia:",
      "flat": "solo"
    },
    model: {
      value: (_vm.cliente.referencia),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "referencia", $$v)
      },
      expression: "cliente.referencia"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Correo:",
      "type": "email",
      "singleLine": ""
    },
    model: {
      value: (_vm.cliente.correo),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "correo", $$v)
      },
      expression: "cliente.correo "
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Teléfono:",
      "type": "tel",
      "singleLine": ""
    },
    model: {
      value: (_vm.cliente.telefono),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "telefono", $$v)
      },
      expression: "cliente.telefono"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Orden:",
      "singleLine": ""
    },
    model: {
      value: (_vm.cliente.orden),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "orden", $$v)
      },
      expression: "cliente.orden"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.dias,
      "label": "Día:",
      "itemText": "text",
      "itemValue": "value"
    },
    model: {
      value: (_vm.cliente.dia),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "dia", $$v)
      },
      expression: "cliente.dia"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.semanas,
      "label": "Semana:",
      "itemText": "text",
      "itemValue": "value"
    },
    model: {
      value: (_vm.cliente.semana),
      callback: function($$v) {
        _vm.$set(_vm.cliente, "semana", $$v)
      },
      expression: "cliente.semana"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.cerrar($event)
      }
    }
  }, [_vm._v("Cerrar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "",
      "disabled": !_vm.activadorcliente
    },
    on: {
      "click": _vm.editarcliente
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8b669d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cliente.vue
// module id = 449
// module chunks = 1